


















import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Login } from '../components';
import { NAME_ROUTES, setAuthorizationHeader, PRIVILEGE_KEYS, PRIVILEGE_TYPES, clearLocalStorage } from '../utils';
import { LoginCredentials, Privileges } from '../models';
import { getAuthWithExpireAt, StorageService } from '../api';
import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../mixins';

@Component({
    components: { Login }
})
export default class LoginPage extends Mixins(RootStoreHelper, AuthStoreHelper, NotificationStoreHelper) {
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.$_completeLoginRequest();
    }

    mounted() {
        clearLocalStorage();
    }

    handleLogin(loginCredentials: LoginCredentials) {
        this.$_initialState();
        this.$_pendingLoginRequest();
        this.$_login(loginCredentials)
            .then(auth => {
                this.$_completeLoginRequest();
                this.$_setUserCredentials(getAuthWithExpireAt(auth));
                StorageService.saveAuth(auth);
                this.$_setMock(!auth.tour);
                setAuthorizationHeader(auth.access_token);
                this.$router.push(NAME_ROUTES.HOME.path);
            })
            .catch(error => {
                this.$_completeLoginRequest();
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Error en proceso de autenticación'
                })
            });
    }
}
